/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ApiInfoEnvironment*`'s.
 */
export type ApiInfoEnvironment = ApiInfoEnvironmentDev | ApiInfoEnvironmentStage | ApiInfoEnvironmentProd;

/**
 * The development environment string type.
 * @export
 */
export type ApiInfoEnvironmentDev = typeof API_INFO_ENVIRONMENT_DEV;
/**
 * The staging environment string type.
 * @export
 */
export type ApiInfoEnvironmentStage = typeof API_INFO_ENVIRONMENT_STAGE;
/**
 * The production environment string type.
 * @export
 */
export type ApiInfoEnvironmentProd = typeof API_INFO_ENVIRONMENT_PROD;

/**
 * The development environment string.
 * @export
 */
export const API_INFO_ENVIRONMENT_DEV = `dev`;

/**
 * The staging environment string.
 * @export
 */
export const API_INFO_ENVIRONMENT_STAGE = `stage`;

/**
 * The production environment string.
 * @export
 */
export const API_INFO_ENVIRONMENT_PROD = `prod`;
